<script>
export default {
    name: 'HelpOverlay',
}
</script>

<template>
    <router-view v-slot="{ Component, }">
        <keep-alive
            include="Help"
            max="1"
        >
            <component :is="Component" />
        </keep-alive>
    </router-view>
</template>
